export default "__VITE_ASSET__799ad153__"